<div class="student-card p-3 p-md-4 level-{{levelKey()}}" *ngIf="student">

  <div class="d-flex flex-column flex-lg-row align-items-lg-start justify-content-between">
    <div class="d-flex align-items-center">
      <coach-student-avatar
        class="me-3" size="lg" [name]="student.name" [levelKey]="levelKey()"></coach-student-avatar>

      <div class="overflow-hidden">
        <p class="fs-24 fw-800 color-gray-950 mb-1 text-truncate">{{student.name}}</p>
        <p class="fs-small fw-400 color-gray-500 mb-0">
          <ng-container *ngFor="let part of metaParts(); let last = last">
            {{part}}<span *ngIf="!last"> · </span>
          </ng-container>
        </p>
      </div>
    </div>

    <div class="mt-3 mt-lg-0">
      <app-gray-button
        color="primary" [fullWidth]="false" padding="py-2 px-3" [weight]="800"
        customClass="plan-btn fs-small" preIcon="calendar"
        [text]="'students.plan_meeting'|translate" (click)="planMeeting()"></app-gray-button>
    </div>
  </div>

  <!-- The exam the boxes below report on; its own row so it never crowds the header. -->
  <div class="exam-switch d-inline-flex mt-3">
    <a class="exam-option text-center fs-small fw-800 clickable px-3 py-1"
       [class.active]="examKey === examKeys.TYT" (click)="setExamKey(examKeys.TYT)">
      {{examName(examKeys.TYT)}}
    </a>
    <a class="exam-option text-center fs-small fw-800 clickable px-3 py-1"
       [class.active]="examKey === examKeys.AYT" (click)="setExamKey(examKeys.AYT)">
      {{examName(examKeys.AYT)}}
    </a>
  </div>

  <div class="row g-2 mt-3">
    <div class="col-6 col-lg-4 col-xl-2">
      <div class="stat-box p-2 h-100">
        <p class="fs-xsmall fw-500 color-gray-400 mb-1">
          {{'students.exam_score'|translate: {exam: examName(examKeys.TYT)}|uppercase}}
        </p>
        <p class="fs-20 fw-800 color-brand-primary-700 mb-0">{{student.base.score ?? '—'}}</p>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-2">
      <div class="stat-box p-2 h-100">
        <p class="fs-xsmall fw-500 color-gray-400 mb-1">
          {{'students.exam_score'|translate: {exam: examName(examKeys.AYT)}|uppercase}}
        </p>
        <p class="fs-20 fw-800 color-gray-950 mb-0">{{student.proficiency.score ?? '—'}}</p>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-2">
      <div class="stat-box p-2 h-100">
        <p class="fs-xsmall fw-500 color-gray-400 mb-1">{{'students.overall'|translate|uppercase}}</p>
        <p class="fs-20 fw-800 color-gray-950 mb-1">%{{overallPercent()}}</p>
        <div class="progress-track">
          <div class="progress-value" [style.width.%]="overallPercent()"></div>
        </div>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-2">
      <div class="stat-box level-box p-2 h-100">
        <p class="fs-xsmall fw-500 color-gray-400 mb-1">{{'students.navi_level'|translate|uppercase}}</p>
        <p class="fs-20 fw-800 color-level-primary mb-0">{{levelName() ?? '—'}}</p>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-2">
      <div class="stat-box p-2 h-100">
        <p class="fs-xsmall fw-500 color-gray-400 mb-1">
          <i class="bi bi-calendar-event me-1"></i>{{'students.first_meeting'|translate|uppercase}}
        </p>
        <p class="fs-small fw-800 color-gray-950 mb-0">
          {{student.meetings.firstAt ? (student.meetings.firstAt|date:'d MMMM y') : '—'}}
        </p>
      </div>
    </div>

    <div class="col-6 col-lg-4 col-xl-2">
      <div class="stat-box p-2 h-100">
        <p class="fs-xsmall fw-500 color-gray-400 mb-1">
          <i class="bi bi-camera-video me-1"></i>{{'students.meetings'|translate|uppercase}}
        </p>
        <p class="fs-small fw-800 color-gray-950 mb-0">
          {{'students.meeting_done'|translate: {count: student.meetings.done} }}
          <span class="color-brand-primary-700"> · {{'students.meeting_next'|translate: {count: student.meetings.next} }}</span>
        </p>
      </div>
    </div>
  </div>

</div>

<coach-student-tabs
  *ngIf="student" class="d-block mt-3"
  [activeTab]="activeTab" [taskProgress]="taskProgress" [unreadMessages]="unreadMessages"
  (tabChanged)="setTab($event)"></coach-student-tabs>

<ng-container *ngIf="student && activeTab === 'progress'">
  <!-- NaviDerece route of the exam the header is reading -->
  <coach-navi-route-card
    class="d-block mt-3"
    [levels]="levels" [examId]="activeExamId()" [examName]="examName(examKey)"
    [exam]="exam()" [studentName]="student.name"></coach-navi-route-card>

  <!-- Net history of the same exam -->
  <coach-exam-history-card
    class="d-block mt-3"
    [studentId]="student.id" [examKey]="examKey" [examName]="examName(examKey)"></coach-exam-history-card>
</ng-container>

<coach-planner-tab
  *ngIf="student && activeTab === 'planner'" class="d-block mt-3"
  [studentId]="student.id" [studentName]="student.name" [levelKey]="levelKey()"></coach-planner-tab>

<coach-videos-tab
  *ngIf="student && activeTab === 'videos'" class="d-block mt-3"
  [studentId]="student.id" [studentName]="student.name"
  (tasksChanged)="getTabBadges()"></coach-videos-tab>

<coach-meeting-notes-tab
  *ngIf="student && activeTab === 'meeting-notes'" class="d-block mt-3"
  [studentId]="student.id"></coach-meeting-notes-tab>

<coach-tasks-tab
  *ngIf="student && activeTab === 'tasks'" class="d-block mt-3"
  [studentId]="student.id" (progressChanged)="taskProgress = $event"></coach-tasks-tab>

<coach-weekly-report-tab
  *ngIf="student && activeTab === 'weekly-report'" class="d-block mt-3"
  [student]="student" [examKey]="examKey" [examName]="examName(examKey)"
  [levelName]="levelName()" [levelKey]="levelKey()"></coach-weekly-report-tab>

<coach-messages-tab
  *ngIf="student && activeTab === 'messages'" class="d-block mt-3"
  [studentId]="student.id" [studentName]="student.name"
  (unreadChanged)="unreadMessages = $event"></coach-messages-tab>

<div class="student-card p-5 text-center" *ngIf="!student && !isLoading">
  <p class="fs-normal fw-800 color-gray-950 mb-1">{{'students.not_found_title'|translate}}</p>
  <p class="fs-small fw-400 color-gray-400 mb-0">{{'students.not_found_desc'|translate}}</p>
</div>
